<p-panel
  [header]="title | translate"
  toggler="header"
  collapseIcon="fa-regular fa-chevron-down"
  expandIcon="fa-regular fa-chevron-up"
  [toggleable]="toggleable"
  [collapsed]="collapsed"
  (collapsedChange)="collapsedChange.emit($event)"
  class="p-panel-inline"
  role="toolbar"
  aria-orientation="vertical"
  [attr.aria-label]="title | translate">
  <ng-container *ngIf="!loading">
    <app-detail-action-buttons
      [items]="config.items"
      [itemClass]="itemClass"
      [checkedItems]="checkedItems"
      (itemClick)="handleClick($event)"></app-detail-action-buttons>
  </ng-container>
  <ng-template #icons>
    <i *ngIf="loading" class="fa-regular fa-arrows-rotate rotate"></i>
  </ng-template>
</p-panel>
